import{gql as e}from"@grandvisionhq/graphql";const t=e`
  query EstimatedDeliveryByEstimationItem($input: EstimatedDeliveryByEstimationItemsInput!) {
    estimatedDeliveryByEstimationItem(input: $input) {
      __typename
      ... on DeliveryEstimationsSuccessResponse {
        __typename
        results {
          shippingMethodKey
          earliestDeliveryDate
          latestDeliveryDate
        }
      }
      ... on DeliveryEstimationsFailureResponse {
        __typename
        failures {
          ... on GenericEstimationFailure {
            message
          }
        }
      }
    }
  }
`;export{t as GET_DELIVERY_ESTIMATION_ITEMS};
//# sourceMappingURL=estimatedDeliveryByEstimationItem.js.map
